import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/hr.png'
import _imports_1 from '../assets/img/eye.png'


const _withScopeId = n => (_pushScopeId("data-v-6fa567f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "story-exhibition bx" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode(" 上进故事展 "),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, " 我想说，上进的人，没有故事。上进心是一种心态，确定了自己的目标... ", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "left" }
const _hoisted_8 = { class: "col-title" }
const _hoisted_9 = { class: "col-content" }
const _hoisted_10 = { class: "eye" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "right" }
const _hoisted_14 = ["src"]

import { StoryFetch } from '@/api/request';
import { IStoryDescProps, PaginationProps } from '@/api/type';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import config from '../_config';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const list = ref<IStoryDescProps[]>([]);
const pagination = ref<PaginationProps>({
  pageNum: 1,
  pageSize: 6
});
const userId = window.localStorage.getItem('userId') || '';
const init = async() => {
  const res = await StoryFetch.getStoryList({
    userId,
    informationType: '1',
    ...pagination.value
  });
  if (res.code === '00') {
    list.value = res.body;
  }
};
const toDetail = (item: IStoryDescProps) => {
  router.push({
    name: 'article',
    query: { scholarshipId: item.scholarshipId }
  });
};

onMounted(() => {
  init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col",
            key: item.id,
            onClick: ($event: any) => (toDetail(item))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.articleTitle), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(item.readNum), 1)
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.createTime), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: 
                'https://yzims.oss-cn-shenzhen.aliyuncs.com/' + item.appPicUrl
              ,
                style: {"width":"100%","height":"100%","border-radius":"5px"}
              }, null, 8, _hoisted_14)
            ])
          ], 8, _hoisted_6))
        }), 128))
      ])
    ])
  ]))
}
}

})